import React, { useContext, useEffect, useRef } from 'react';
import { useRouter } from 'next/router';
import { DimensionsContext } from '../context/ThemeContextManagement';

const SiteResize = () => {
  const context = useContext(DimensionsContext);
  const router = useRouter();

  const lvhElRef = useRef(null);

  const setDimensions = context?.setDimensions;

  useEffect(() => {
    if (!setDimensions) return;

    // create reusable 100lvh element
    const el = document.createElement('div');

    el.style.position = 'absolute';
    el.style.top = '0';
    el.style.height = '100lvh';
    el.style.visibility = 'hidden';
    el.style.pointerEvents = 'none';
    el.style.zIndex = '-1';

    document.body.appendChild(el);
    lvhElRef.current = el;

    const get100lvh = () => {
      if (!lvhElRef.current) return window.innerHeight;
      return lvhElRef.current.offsetHeight;
    };

    const updateDimensions = () => {
      const newDimensions = {
        screenWidth: window.innerWidth,
        screenHeight: window.innerHeight,
        lvhHeight: get100lvh(),
        bodyHeight: document.body.scrollHeight,
      };

      setDimensions(newDimensions);
    };

    // debounce resize
    let timeoutId;

    const debouncedUpdate = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(updateDimensions, 100);
    };

    const handleComplete = () => {
      updateDimensions();
    };

    window.addEventListener('resize', debouncedUpdate);
    router.events.on('routeChangeComplete', handleComplete);

    // initial
    updateDimensions();

    return () => {
      clearTimeout(timeoutId);

      window.removeEventListener('resize', debouncedUpdate);
      router.events.off('routeChangeComplete', handleComplete);

      if (lvhElRef.current) {
        lvhElRef.current.remove();
        lvhElRef.current = null;
      }
    };
  }, [setDimensions, router.events]);

  return null;
};

export default SiteResize;
